export default {
    title: 'Ha solicitado con éxito una clase de prueba individual por gratis',
    title1: 'Por favor espere hasta que nuestro asesor le contacte',
    title2: 'O usted puede escanear el código QR en Whatsapp y contactar a nuestro asesor',
    title3: `Síganos en Facebook para obtener materiales de estudio gratuitos`,
    title4: `Su solicitud ha sido revisada y por favor agregue la cuenta de Whatsapp de 
    abajo por más informaciones en adelante `,
    title5: `Cuenta de Whatsapp`,
    title6: `Su primera clase es totalmente gratuita y vamos a ofrecerle aparte materiales de
    estudio después de su asistencia`,
    title7: `Su solicitud ha sido revisada y le vamos a contactar en 24 horas, por favor
    preste atención a las llamadas entrantes`,
    copy: 'Copiar',
    copied: 'Copiado',
    success: 'Éxito',
}